<template>
   <div class='infograph-card'>
      <infographics-card-header
         :title="data.title"
      />
      <vue-scroll>
         <div class="body" :class="{'vertical': vertical}">
            <infographics-item
               v-for="item in data.items"
               :key="item.id"
               :item="item"
               :box-shaped="!vertical"
            />
         </div>
      </vue-scroll>
   </div>
</template>

<script>
import InfographicsItem from '../../../molecules/Home/InfographicsItem';
import InfographicsCardHeader from '../../../molecules/Home/InfographicsCardHeader';

export default {
   name: 'infographics-card',
   components: {
      InfographicsItem,
      InfographicsCardHeader,
   },
   props: {
      data: {
         type: Object,
         required: true,
         validator: data =>
         {
            return data.title && data.items && data.items instanceof Array;
         },
      },
      vertical: {
         type: Boolean,
         default: false,
      }
   }
}
</script>

<style lang="scss" scoped>
.infograph-card {
   height: 100%;
   $border-color: lighten($secondary-color, 40%);
   display: grid;
   grid-template-rows: auto 1fr;

   .body {
      padding: 2px;
      display: grid;
      grid-template-columns: 1fr 1fr;
      grid-gap: 2px;

      &.vertical {
         grid-template-columns: 1fr;
      }
   }
}
</style>